import img19a from '../../../assets/gallery/19a/19a-01-HOME_Variaciones-e-improvisaciones-2019-200x179cm-oleo-sobre-madera.jpg';
import img19b from '../../../assets/gallery/19a/19a-02_ST-2019-165x133cm-oleo-sobre-tela.jpg';
import img19c from '../../../assets/gallery/19a/19a-03_ST-2019-165x133cm-oleo-sobre-tela.jpg';
import img19d from '../../../assets/gallery/19a/19a-04_Pintura-gris-2019-200x180cm-oleo-sobre-madera.jpg';
import img19e from '../../../assets/gallery/19a/19a-05_ST-2019-200x180cm-oleo-sobre-madera.jpg';
import img19f from '../../../assets/gallery/19a/19a-06_ST-2019-216x183cm-oleo-sobre-madera.jpg';

export const dataImages = [
  {
    id: 1,
    title: "",
    dimensions: "200 x 179 cm",
    pictureSrc: img19a,
    description: "2019",
    orientation: "h"
  },
  {
    id: 2,
    title: "",
    dimensions: "165 x 133 cm",
    pictureSrc: img19b,
    description: "2019",
    orientation: "h"
  },
  {
    id: 3,
    title: "",
    dimensions: "165 x 133 cm",
    pictureSrc: img19c,
    description: "2019",
    orientation: "h"
  },
  {
    id: 4,
    title: "",
    dimensions: "200 x 180 cm",
    pictureSrc: img19d,
    description: "2019",
    orientation: "h"
  },
  {
    id: 5,
    title: "",
    dimensions: "200 x 180 cm",
    pictureSrc: img19e,
    description: "2019",
    orientation: "h"
  },
  {
    id: 6,
    title: "",
    dimensions: "216 x 183 cm",
    pictureSrc: img19f,
    description: "2019",
    orientation: "h"
  },
].sort(() => Math.random() - 0.5);

export const dimensionsH = [
  { width: "820" },
  { width: "730" },
  { width: "700" },
  { width: "650" },
  { width: "539" },
  { width: "444" },
  { width: "400" },
  { width: "382" },
];


export const dimensionsV = [
  { width: "820" },
  { width: "730" },
  { width: "700" },
  { width: "650" },
  { width: "539" },
  { width: "444" },
  { width: "400" },
  { width: "382" },
];


// WEBPACK FOOTER //
// ./src/pages/gallery/19a/data19a.js